
















































import Vue from "vue";
import { apiv1 } from "../../libs/apiv1";
import { oAuth } from "../../classes/Auth";

enum Prioridad {
  baja = 1,
  media,
  alta
}

export default Vue.extend({
  name: "Alertas",
  props: {
    source: String
  },
  components: {},
  async mounted() {
    await this.getAlerts();
    console.log(this.alerts)
  },
  data: () => ({
    search: "",
    prioridad_colors: ["yellow", "orange", "red"],
    headers: [
      { text: "Punto", value: "carga" },
      { text: "Hora y fecha", value: "fecha" },
      { text: "Consumo", value: "consumo" },
      { text: "Porcentaje", value: "diferencia" },
      { text: "Prioridad", value: "prioridad" },
      { text: "Observaciones", value: "observaciones" },
      { text: "Revisado", value: "revisado" }
    ],
    prioridad: Prioridad,
    alerts: [],
    data: []
  }),
  methods: {
    genColor(i: number) {
      return this.prioridad_colors[i];
    },
    async getAlerts() {
      const { data } = await apiv1({
        url: `/alerts?project=${oAuth.getProject().id}`,
        method: "GET"
      });
      this.alerts = data || [];
    },
    async changeEstate(item: any) {
      const { data } = await apiv1({
        url: `/alert/${item.id}`,
        method: "PUT",
        data: {
          revisado: !item.revisado ? false : item.revisado,
        }
      });

      const alertsNum = this.alerts.filter((val: any) => { 
        return !val.revisado ? false : !val.revisado
      });
      this.$store.commit("setAlertsNum", alertsNum ? alertsNum.length : 0);
    }
  }
});
